// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Spinner = function Spinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.852 14.531c.449.258 1.027.106 1.242-.363A10 10 0 0 0 20 10C20 4.793 16.02.516 10.938.043 10.422-.004 10 .418 10 .938s.422.933.938.992A8.123 8.123 0 0 1 18.125 10a8.15 8.15 0 0 1-.664 3.227c-.207.476-.059 1.047.39 1.308z"
  }));
};
